<template>
    <ErrorPage>
        <template slot="Title">
            This looks empty
        </template>
        <template slot="SubTitle">
        </template>
        <template slot="Content">
           Search your library to add tracks here
        </template>
        <template slot="Actions">
            <button>Quick search tracks</button>
            <button>Upload tracks</button>
        </template>
    </ErrorPage>
</template>

<script>
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import Button from'@/components/common/Button'
    export default {
        name: "BoxTrackListEmpty",
        components: {
            ErrorPage
        },
    }
</script>

<style scoped>
</style>